/**
 * Core permission keys for the entire application.
 * These are shared across all user types (admin, manager, external user).
 */
export const CORE_PERMISSIONS = {
    // Dashboard permissions
    VIEW_BOOKING_DASHBOARD: "VIEW_BOOKING_DASHBOARD",
    VIEW_SURVEY_DASHBOARD: "VIEW_SURVEY_DASHBOARD",
    // User management permissions
    MANAGE_ADMINISTRATORS: "MANAGE_ADMINISTRATORS",
    MANAGE_MANAGERS: "MANAGE_MANAGERS",
    MANAGE_ACCESS_ROLES: "MANAGE_ACCESS_ROLES",
    MANAGE_RECIPIENTS: "MANAGE_RECIPIENTS",
    // Respondent permissions
    MANAGE_RESPONDENTS: "MANAGE_RESPONDENTS",
    RESPONDENT_LIST: "RESPONDENT_LIST",
    RESPONDENT_READ: "RESPONDENT_READ",
    RESPONDENT_WRITE: "RESPONDENT_WRITE",
    RESPONDENT_DOCUMENT_READ: "RESPONDENT_DOCUMENT_READ",
    RESPONDENT_DOCUMENT_WRITE: "RESPONDENT_DOCUMENT_WRITE",
    RESPONDENT_NOTE_READ: "RESPONDENT_NOTE_READ",
    RESPONDENT_NOTE_WRITE: "RESPONDENT_NOTE_WRITE",
    RESPONDENT_CONTACT_READ: "RESPONDENT_CONTACT_READ",
    RESPONDENT_CONTACT_WRITE: "RESPONDENT_CONTACT_WRITE",
    MANAGE_RESPONDENT_COMPANIES: "MANAGE_RESPONDENT_COMPANIES",
    MANAGE_RESPONDENT_CONTACTS: "MANAGE_RESPONDENT_CONTACTS",
    // Booking permissions
    MANAGE_BOOKINGS: "MANAGE_BOOKINGS",
    BOOKING_READ: "BOOKING_READ",
    BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS: "BOOKING_READ_INCLUDE_ALL_RESPONDENT_BOOKINGS",
    BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS: "BOOKING_READ_INCLUDE_AFFILIATE_BOOKINGS",
    BOOKING_WRITE: "BOOKING_WRITE",
    BOOKING_CREATE_VIA_BOOKING_PAGE: "BOOKING_CREATE_VIA_BOOKING_PAGE",
    BOOKING_CREATE_VIA_CALENDAR: "BOOKING_CREATE_VIA_CALENDAR",
    EVENT_CREATE_VIA_CALENDAR: "EVENT_CREATE_VIA_CALENDAR",
    BOOKING_DOCUMENT_READ: "BOOKING_DOCUMENT_READ",
    BOOKING_DOCUMENT_WRITE: "BOOKING_DOCUMENT_WRITE",
    BOOKING_CALENDAR_READ: "BOOKING_CALENDAR_READ",
    MANAGE_BOOKING_COMPANIES: "MANAGE_BOOKING_COMPANIES",
    MANAGE_CONFIRMATION_TEXT: "MANAGE_CONFIRMATION_TEXT",
    MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES: "MANAGE_SERVICES_LOCATIONS_BOOKING_PAGES",
    MANAGE_BOOKING_PAGE_COMPANIES: "MANAGE_BOOKING_PAGE_COMPANIES",
    // Survey permissions
    MANAGE_SURVEY_TYPES: "MANAGE_SURVEY_TYPES",
    MANAGE_SURVEY_BACKGROUNDS: "MANAGE_SURVEY_BACKGROUNDS",
    SURVEY_READ: "SURVEY_READ",
    SURVEY_WRITE: "SURVEY_WRITE",
    SURVEY_COMPLETED_SEND: "SURVEY_COMPLETED_SEND",
    VIEW_REPORTS: "VIEW_REPORTS",
    VIEW_FLAGGED_QUESTIONS: "VIEW_FLAGGED_QUESTIONS",
    // Invoicing and Payments permissions
    CONFIGURE_INVOICING_AND_PAYMENTS: "CONFIGURE_INVOICING_AND_PAYMENTS",
    MANAGE_INVOICING_AND_PAYMENTS_SYSTEM_CONFIG: "MANAGE_INVOICING_AND_PAYMENTS_SYSTEM_CONFIG",
    MANAGE_TAX_RATES: "MANAGE_TAX_RATES",
    MANAGE_ITEMS: "MANAGE_ITEMS",
    MANAGE_ACTIVITY_ITEMS: "MANAGE_ACTIVITY_ITEMS",
    // Manage Invoices
    MANAGE_INVOICES: "MANAGE_INVOICES",
    VIEW_INVOICES: "VIEW_INVOICES",
    CREATE_INVOICE: "CREATE_INVOICE",
    EDIT_INVOICE: "EDIT_INVOICE",
    CHANGE_INVOICE_STATUS: "CHANGE_INVOICE_STATUS",
    EXPORT_AND_SEND_INVOICE: "EXPORT_AND_SEND_INVOICE",
    // Charges and Payments permissions
    MANAGE_CHARGES_AND_PAYMENTS: "MANAGE_CHARGES_AND_PAYMENTS",
    REFUND_PAYMENT: "REFUND_PAYMENT",
    PERFORM_CHARGE: "PERFORM_CHARGE",
    VIEW_PAYMENT_HISTORY: "VIEW_PAYMENT_HISTORY",
    // Other permissions
    MANAGE_APP_CONFIGURATIONS: "MANAGE_APP_CONFIGURATIONS",
    MANAGE_API: "MANAGE_API",
    MANAGE_BILLING: "MANAGE_BILLING",
    MANAGE_COMPANIES: "MANAGE_COMPANIES",
    MANAGE_TEMPLATES: "MANAGE_TEMPLATES",
    // AI related
    VIEW_QUICK_START: "VIEW_QUICK_START",
    // Workflows and Automations
    MANAGE_WORKFLOWS: "MANAGE_WORKFLOWS",
    READ_WORKFLOWS: "READ_WORKFLOWS",
    WRITE_WORKFLOWS: "WRITE_WORKFLOWS",
    DELETE_WORKFLOWS: "DELETE_WORKFLOWS",
};
//# sourceMappingURL=corePermissionKeys.js.map